import { ProIcon } from '../icons/ProIcon';

/** Web twin of PremiumMark.tsx (`ProIcon` resolves to its own `.web` twin). */
export function PremiumMark({ size = 20, color }: { size?: number; color?: string }) {
  return <ProIcon size={size} color={color} boxed={false} />;
}
